import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Collapse, Card } from 'antd';
import { getAllNotificationsCount } from '../../services/notificationService';
import FactoryAuditNotificationsDataTable from '../../components/notifications/notificationDataTable';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getDateRanges } from '../../utils/commonUtil';
const { Panel } = Collapse;
export const FactoryAuditNotifications = () => {
    const [factoryAuditNotifications, setFactoryAuditNotifications] = useState([]);
    const [factoryAuditShowToday, setFactoryAuditShowToday] = useState([]);
    const [factoryAuditShowNext30, setFactoryAuditShowNext30] = useState([]);
    const [factoryAuditThisWeek, setFactoryAuditThisWeek] = useState([]);
    const [factoryAuditLastWeek, setFactoryAuditLastWeek] = useState([]);
    const [factoryAuditTwoWeeksAgo, setFactoryAuditTwoWeeksAgo] = useState([]);
    const [factoryAuditThreeWeeksAgo, setFactoryAuditThreeWeeksAgo] = useState([]);
    const [factoryAuditNotifyCount, setFactoryAuditNotifyCount] = useState();
    const [key, setKey] = useState('');
    const [activeKeys, setActiveKeys] = useState([]);
    const location = useLocation();
    const { keyValue, data } = location.state || {};
    const applicationData = useSelector((state) => state.applicationData); //useApplicationContext();
    useEffect(() => {
        const lstLuCompany = applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList;
        getAllNotificationsCount(lstLuCompany, 'getAllFactoryAuditNotifications').then((res) => {
            const today = [];
            const next30 = [];
            const thisWeek = [];
            const lastWeek = [];
            const twoWeeksAgo = [];
            const threeWeeksAgo = [];
            res.forEach((item) => {
                var _a, _b, _c, _d, _e, _f;
                if (((_a = item === null || item === void 0 ? void 0 : item.objStatus) === null || _a === void 0 ? void 0 : _a.intId) === 100) {
                    today.push(item);
                }
                if (((_b = item === null || item === void 0 ? void 0 : item.objStatus) === null || _b === void 0 ? void 0 : _b.intId) === 110) {
                    next30.push(item);
                }
                if (((_c = item === null || item === void 0 ? void 0 : item.objStatus) === null || _c === void 0 ? void 0 : _c.intId) === 120) {
                    thisWeek.push(item);
                }
                if (((_d = item === null || item === void 0 ? void 0 : item.objStatus) === null || _d === void 0 ? void 0 : _d.intId) === 130) {
                    lastWeek.push(item);
                }
                if (((_e = item === null || item === void 0 ? void 0 : item.objStatus) === null || _e === void 0 ? void 0 : _e.intId) === 140) {
                    twoWeeksAgo.push(item);
                }
                if (((_f = item === null || item === void 0 ? void 0 : item.objStatus) === null || _f === void 0 ? void 0 : _f.intId) === 150) {
                    threeWeeksAgo.push(item);
                }
            });
            setFactoryAuditNotifications(res);
            setFactoryAuditShowToday(today);
            setFactoryAuditShowNext30(next30);
            setFactoryAuditThisWeek(thisWeek);
            setFactoryAuditLastWeek(lastWeek);
            setFactoryAuditTwoWeeksAgo(twoWeeksAgo);
            setFactoryAuditThreeWeeksAgo(threeWeeksAgo);
        });
        setKey(keyValue);
        setFactoryAuditNotifyCount(data);
        // Set active keys based on the keyValue or SHOWALL
        const keys = [];
        if (keyValue === "TODAY" || keyValue === "SHOWALL")
            keys.push('1');
        if (keyValue === "NEXT30" || keyValue === "SHOWALL")
            keys.push('2');
        if (keyValue === "THISWEEK" || keyValue === "SHOWALL")
            keys.push('3');
        if (keyValue === "LASTWEEK" || keyValue === "SHOWALL")
            keys.push('4');
        if (keyValue === "LASTTWOWEEKS" || keyValue === "SHOWALL")
            keys.push('5');
        if (keyValue === "LASTTHREEWEEKS" || keyValue === "SHOWALL")
            keys.push('6');
        setActiveKeys(keys);
    }, [keyValue]);
    const handleCollapseChange = (keys) => {
        setActiveKeys(Array.isArray(keys) ? keys : [keys]);
    };
    const ranges = getDateRanges();
    return (_jsx(Card, { title: "Factory Audit Notifications", children: _jsxs(Collapse, { activeKey: activeKeys, onChange: handleCollapseChange, children: [_jsx(Panel, { header: `Expiring Today (${factoryAuditShowToday.length}) (${ranges.expiringToday})`, children: _jsx(FactoryAuditNotificationsDataTable, { data: factoryAuditShowToday }) }, "1"), _jsx(Panel, { header: `Next 30 Days (${factoryAuditShowNext30.length}) (${ranges.next30Days})`, children: _jsx(FactoryAuditNotificationsDataTable, { data: factoryAuditShowNext30 }) }, "2"), _jsx(Panel, { header: `Expired This Week (${factoryAuditThisWeek.length}) (${ranges.thisWeek})`, children: _jsx(FactoryAuditNotificationsDataTable, { data: factoryAuditThisWeek }) }, "3"), _jsx(Panel, { header: `Expired Last Week (${factoryAuditLastWeek.length}) (${ranges.lastWeek})`, children: _jsx(FactoryAuditNotificationsDataTable, { data: factoryAuditLastWeek }) }, "4"), _jsx(Panel, { header: `Expired Two Weeks Ago (${factoryAuditTwoWeeksAgo.length}) (${ranges.twoWeeksAgo})`, children: _jsx(FactoryAuditNotificationsDataTable, { data: factoryAuditTwoWeeksAgo }) }, "5"), _jsx(Panel, { header: `Expired Three Weeks Ago (${factoryAuditThreeWeeksAgo.length}) (${ranges.threeWeeksAgo})`, children: _jsx(FactoryAuditNotificationsDataTable, { data: factoryAuditThreeWeeksAgo }) }, "6")] }) }));
};
export default FactoryAuditNotifications;
